import {plainTextToEmailHtml} from './plainTextToEmailHtml';
import {replaceVariables} from './replaceVariables';

/**
 * Prepares a rendered message template for the editor.
 *
 * A template body arrives as plain text with placeholders and newlines. Both steps are needed and
 * neither is optional: an unfilled placeholder becomes the underscore run the author expects, and
 * the newlines become paragraphs instead of collapsing into one.
 */
export const templateBodyToEmailHtml = (body: string) =>
  plainTextToEmailHtml(replaceVariables(body));
